/*
pages
*/
//root
import Root from "../pages/Root/index";
import Login from "../pages/Authentication/Login";
import Logout from "../pages/Authentication/Logout";
import Register from "../pages/Authentication/Register";
import RecoverPassword from "../pages/Authentication/RecoverPassword";
import ChangePassword from "../pages/Authentication/ChangePassword";
import LockScreen from "../pages/Authentication/LockScreen";
import { Navigate } from "react-router-dom";

// dashboard
import Dashboard from "../pages/Dashboard/index";
import StarterPage from "../pages/StarterPage/index";
import FacebookAuth from "../pages/Authentication/FacebookAuth";

interface RouteProps {
  path: string;
  component: any;
  exact?: boolean;
}

const publicRoutes: Array<RouteProps> = [
  { path: "/auth-login", component: <Login /> },
  { path: "/auth-register", component: <Register /> },
  { path: "/auth-recoverpw", component: <RecoverPassword /> },
  { path: "/auth-changepassword", component: <ChangePassword /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
  { path: "/logout", component: <Logout /> },
  { path: "/auth-facebook", component: <FacebookAuth /> },
];

const privateRoutes: Array<RouteProps> = [
  { path: "/pages-starter", component: <StarterPage /> },
  { path: "/dashboard", component: <Dashboard /> },
  { path: "/", component: <Root /> },
];

// const privateRoutes: Array<RouteProps> = [
//   { path: "/", component: <StarterPage /> }, // 👈 HUB
//   { path: "/chat", component: <Dashboard /> }, // 👈 teu chat atual
//   { path: "/agent", component: <StarterPage /> }, // 👈 depois você troca por AgentPage
//   { path: "/dashboard", component: <Dashboard /> },
// ];

export { publicRoutes, privateRoutes };
